import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    dataUser: null
}

export const userSlice = createSlice({
    name: 'users',
    initialState,
    reducers: {
        setDataUser: (state, { payload }) => {
            state.dataUser = payload
        }
    },
    resetStateDataUser: () => initialState
})

export const { setDataUser } = userSlice.actions
export default userSlice.reducer
